export default function CustomSVG({SvgFunction, height, width, ...props}) {
    props.style = {
        ...props.style,
        outline: "none"
    }

    return <SvgFunction
        height={height ? height : SvgFunction().props.height}
        width={width ? width : SvgFunction().props.width}
        viewBox={`0 0 ${SvgFunction().props.width} ${SvgFunction().props.height}`}
        {...props}
    />
}